import { useId } from 'react';
import { COLORS } from '../../styles/design-tokens';
import { TRADES } from '../../lib/tradeOpportunities';

export default function TradePicker({ selectedTrade = '', onChange, theme }) {
  const id = useId();
  const colors = theme || { text: COLORS.text, bgCard: COLORS.card, border: COLORS.cardBorder };
  return (
    <div style={{ marginBottom: 16, maxWidth: 360 }}>
      <label htmlFor={id} style={{ display: 'block', color: colors.text, fontSize: 13, fontWeight: 700, marginBottom: 6 }}>Choose a trade</label>
      <select id={id} value={selectedTrade} onChange={event => onChange(event.target.value)} style={{ width: '100%', minHeight: 44, background: colors.bgCard, border: `1px solid ${colors.border}`, borderRadius: 8, padding: '10px 12px', color: colors.text, font: 'inherit', fontSize: 'var(--text-input, 16px)', cursor: 'pointer' }}>
        <option value="">All trades</option>
        {TRADES.map(trade => <option key={trade.id} value={trade.id}>{trade.label}</option>)}
      </select>
    </div>
  );
}
